import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import React, { useContext } from 'react';
import DesktopProfileTop728x90 from '@wix/da-ads/pkg/adunits/anon/DesktopProfileTop728x90';
import UserDesktopProfileTop728x90 from '@wix/da-ads/pkg/adunits/user/DesktopProfileTop728x90';
import DesktopProfileBottom728x90 from '@wix/da-ads/pkg/adunits/anon/DesktopProfileBottom728x90';
import UserDesktopProfileBottom728x90 from '@wix/da-ads/pkg/adunits/user/DesktopProfileBottom728x90';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import UpsellWrapper from '@wix/da-shared-react/pkg/Ads/UpsellWrapper';
import { SafetyState } from '@wix/da-ads/pkg/constants';

import s from './LeaderboardWrapper.scss';

export interface Props {
  children: React.ReactNode;
  adSafety: string;
  adSafetyState: SafetyState;
  folderId: number;
  hasMore: boolean;
  pagingMode: 'scroll' | 'page';
}

const LeaderboardWrapper: React.FC<Props> = ({
  children,
  adSafety,
  adSafetyState,
  hasMore,
  pagingMode,
}) => {
  const isMobile = useContext(MobileContext);
  const showAd = useShouldRenderAdArea(adSafety);
  const adsType = useAdsType();
  const isLoggedUpAds = useFlag('ads_loggedin_up');

  if (isMobile || !showAd || (adsType !== 'anon' && !isLoggedUpAds)) {
    return <>{children}</>;
  }

  return (
    <>
      <UpsellWrapper
        className={s['top-wrap']}
        unit="DesktopBrowseRight160x600"
        upsellType="small"
      >
        <div className={s['top']}>
          <ErrorBoundary debugComponent="DesktopProfileTopDisplay728x90">
            <AnonOrUserUnit
              anon={DesktopProfileTop728x90}
              user={UserDesktopProfileTop728x90}
              safety={adSafety}
              safetyState={adSafetyState}
            />
          </ErrorBoundary>
        </div>
      </UpsellWrapper>
      {children}
      <div className={s['bottom']}>
        {((pagingMode === 'scroll' && !hasMore) || pagingMode === 'page') && (
          <ErrorBoundary debugComponent="DesktopProfileBottomDisplay728x90">
            <AnonOrUserUnit
              anon={DesktopProfileBottom728x90}
              user={UserDesktopProfileBottom728x90}
              safety={adSafety}
              safetyState={adSafetyState}
            />
          </ErrorBoundary>
        )}
      </div>
    </>
  );
};
LeaderboardWrapper.displayName = 'LeaderboardWrapper';

export default LeaderboardWrapper;
